export default function getServiceWorkerCacheHitData() {
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    return new Promise((resolve, reject) => {
      const channel = new MessageChannel();
      channel.port1.onmessage = function(event) {
        if (event.data.error) {
          reject(event.data.error);
        } else {
          resolve(event.data);
        }
      };
      navigator.serviceWorker.controller.postMessage({ name: 'getCacheHitData' }, [channel.port2]);
    });
  }
  return Promise.resolve({ hits: [], misses: [] });
}
